<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-delete"
      title="Delete User"
      ok-only
      ok-title="Delete"
      @ok="deleteItem"
      @hide="resetForm"
    >
      <b-card-text>
        <h5>{{ $t("common.delete-sure") }}</h5>
        {{ $t("common.sure-click") }}
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('lab.test')}`
          : `${$t('common.edit')} ${$t('lab.test')}`
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <AutoComplete
              :label="$t('lab.test-devices')"
              :placeholder="$t('lab.test-devices')"
              v-model="EditForm.test_device_id"
              :serializer="(val) => val"
              param-query="name"
              filter="id"
              endpoint="testDevices"
              text-title="name"
              style="flex: 1"
            />
          </b-col>
          <b-col md="4">
            <b-form-group
              :label="$t('common.device_test_name')"
              label-for="device_test_name"
            >
              <b-form-input
                v-model="EditForm.device_test_name"
                :placeholder="$t('common.device_test_name')"
              />
              <p class="text-danger mt-1">{{ errorForm.device_test_name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <AutoComplete
              :label="$t('lab.unit')"
              :placeholder="$t('lab.unit')"
              v-model="EditForm.unit_id"
              :serializer="(val) => val"
              param-query="name"
              endpoint="unit"
              text-title="name"
              style="flex: 1"
            />
            <p class="text-danger mt-1">{{ errorForm.unit_id }}</p>
          </b-col>

          <b-col md="4">
            <b-form-group :label="$t('common.price')" label-for="name">
              <b-form-input
                type="number"
                v-model="EditForm.price"
                :placeholder="$t('common.price')"
              />
              <p class="text-danger mt-1">{{ errorForm.price }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.edit")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('lab.test')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("lab.test") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('lab.test_name')"
              :placeholder="$t('lab.test_name')"
              v-model="testName"
              :serializer="(val) => val.name"
              param-query="name"
              endpoint="test"
              text-title="name"
              style="flex: 1"
            />
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.price')" label-for="name">
              <b-form-input
                type="number"
                v-model="priceFilter"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getTestList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("common.table") }} {{ $t("lab.test") }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-test')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.create") }} {{ $t("lab.test") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <!-- normalRange -->
          <template #cell(normalRange)="data">
            <v-table dense v-if="data.item.normal_ranges.length > 0">
              <thead>
                <tr>
                  <th>{{ $t("lab.gender") }}</th>
                  <th>{{ $t("lab.min") }}</th>
                  <th>{{ $t("lab.max") }}</th>
                  <th>{{ $t("lab.min_age") }}</th>
                  <th>{{ $t("lab.max_age") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in data.item.normal_ranges"
                  :key="`range-${item.id}-${index}`"
                >
                  <td>{{ item.gender }}</td>
                  <td>{{ item.min }}</td>
                  <td>{{ item.max }}</td>
                  <td>{{ item.min_age }}</td>
                  <td>{{ item.max_age }}</td>
                </tr>
              </tbody>
            </v-table>
          </template>

          <template #cell(actions)="data">
            <ActionsButtons
              deletePerm="delete-test"
              editPerm="update-test"
              @editToggle="show(data.item, 'edit')"
              @deleteToggle="deleteModel(data.item)"
            />
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("lab.test") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getTestList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");

export default {
  mixins: [permissionChecker],
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    ActionsButtons,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        price: "",
        device_test_name: "",
        test_device_id: "",
        unit_id: "",
        normalRange: 0,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        price: "",
        device_test_name: "",
        test_device_id: "",
        unit_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        {
          key: "device_test_name",
          label: this.$t("common.device_test_name"),
          sortable: true,
        },
        {
          key: "normalRange",
          label: this.$t("lab.normalRange"),
          sortable: true,
        },
        { key: "price", label: this.$t("common.price"), sortable: true },
        {
          key: "test_device.name",
          label: this.$t("lab.test_device"),
          sortable: true,
        },
        {
          key: "unit.name",
          label: this.$t("lab.unit"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      testName: "",
      priceFilter: "",
    };
  },
  mounted() {
    this.getTestList();
  },
  methods: {
    resetForm() {
      this.EditForm = {
        name: "",
        price: "",
        device_test_name: "",
        test_device_id: "",
        unit_id: "",
        _method: "POST",
      };
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          price: "",
          unit_id: "",
          normalRange: "",
          test_device_id: "",
          device_test_name: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.price = item.price;
        this.EditForm.unit_id = item.unit_id;
        this.EditForm.test_device_id = item.test_device_id;
        this.EditForm.device_test_name = item.device_test_name;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getTestList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/test?page=${this.page}&take=${this.take}&sort=-id&include=normalRanges,testDevice,unit`;

      if (this.testName) {
        url += `&filter[name]=${this.testName}`;
      }
      if (this.priceFilter) {
        url += `&filter[price]=${this.priceFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/test/${this.deleteForm.id}`)
        .then((response) => {
          this.getTestList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // console.log("result", result);
      return result;
    },
    submitItem() {
      console.log(this.EditForm);
      this.loading = true;
      let count = 0;
      this.errorForm.name = "";
      this.errorForm.price = "";
      this.errorForm.unit_id = "";
      this.errorForm.device_test_name = "";
      this.errorForm.test_device_id = "";
      // console.log(this.EditForm);
      // return;
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null) {
          console.log(this.EditForm[item]);
          delete this.EditForm[item];
        }
      }
      let unit_id =this.EditForm.unit_id;

      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }

      if (!this.EditForm.price) {
        count++;
        this.errorForm.price = "The price field is required.";
      }

      if (!unit_id) {
        count++;
        this.errorForm.unit_id = "The unit id field is required.";
      }

      if (!this.EditForm.device_test_name) {
        count++;
        this.errorForm.device_test_name =
          "The device test name field is required.";
      }

      if (!this.EditForm.test_device_id) {
        count++;
        this.errorForm.test_device_id = "The test device id field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }
      const payload = {
        name: this.EditForm.name,
        price: this.EditForm.price,
        unit_id: this.EditForm.unit_id.id,
        device_test_name: this.EditForm.device_test_name,
        test_device_id: this.getNestedProperty(this.EditForm, "test_device_id.id"),
      };

      if (this.createMode) {
        (this.params.form = payload),
          (this.params.path = `/test`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getTestList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        payload._method = "PUT";
        (this.params.form = payload),
          (this.params.path = `/test/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getTestList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                this.loading = false;
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
